import {
    SETTINGS_SEO_LISTING_DESCRIPTION,
    SETTINGS_SEO_LISTING_TITLE,
    SETTINGS_SEO_PRODUCT_DESCRIPTION,
    SETTINGS_SEO_PRODUCT_TITLE,
    SETTINGS_SEO_STATIC_DESCRIPTION,
    SETTINGS_SEO_STATIC_TITLE,
} from '../../constants';
import { type SettingsValue, useSettingsFactory } from './useSettingsFactory';

export type SettingSeoTemplate = SettingsValue<
    | typeof SETTINGS_SEO_PRODUCT_TITLE
    | typeof SETTINGS_SEO_PRODUCT_DESCRIPTION
    | typeof SETTINGS_SEO_LISTING_TITLE
    | typeof SETTINGS_SEO_LISTING_DESCRIPTION
    | typeof SETTINGS_SEO_STATIC_TITLE
    | typeof SETTINGS_SEO_STATIC_DESCRIPTION
>;

export const useSettingsSeo = () =>
    useSettingsFactory({
        productTitle: { path: SETTINGS_SEO_PRODUCT_TITLE },
        productDescription: { path: SETTINGS_SEO_PRODUCT_DESCRIPTION },
        listingTitle: { path: SETTINGS_SEO_LISTING_TITLE },
        listingDescription: { path: SETTINGS_SEO_LISTING_DESCRIPTION },
        staticTitle: { path: SETTINGS_SEO_STATIC_TITLE },
        staticDescription: { path: SETTINGS_SEO_STATIC_DESCRIPTION },
    });

export type SettingSeoPaths = ReturnType<typeof useSettingsSeo>['values'][keyof ReturnType<
    typeof useSettingsSeo
>['values']]['path'];
